export default "__VITE_ASSET__92c37914__"